<template>
    <component :is="activeComponent" />
</template>

<script>
import { onClientReady, featureFlags } from '@/scripts/FeatureFlags';

export default {
    name: 'FeatureFlagView',
    props: {
        flagName:     { type: String,             required: true },
        newComponent: { type: [Object, Function], required: true },
        oldComponent: { type: [Object, Function], required: true },
    },
    data() {
        return { flagEnabled: false, flagsReady: false };
    },
    computed: {
        activeComponent() {
            return this.flagsReady && this.flagEnabled
                ? this.newComponent
                : this.oldComponent;
        }
    },
    created() {
        onClientReady(() => {
            this.flagEnabled = !!featureFlags[this.flagName];
            this.flagsReady = true;
        });
    }
}
</script>
